import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M6.25 17.75L6.25 19.25L4.75 19.25L4.75 17.75L6.25 17.75Z" fill="currentColor" />
		<Path d="M4.75 11H5C9.41828 11 13 14.5817 13 19V19.25M19 19.25V19C19 11.268 12.732 5 5 5H4.75" strokeLinecap="square" />
	</SVG>
);
